module.exports = __webpack_public_path__ + "img/edge.d0077b48.png";